import React from 'react';
import { ReactSVG } from 'react-svg';
import { IconSaxIcon } from '@/components/design-system/atoms/icon/iconsax-icon';
import { IconSaxIconProps } from '@/components/design-system/atoms/icon/iconsax-icon/types';
import { HeroIconsProps } from '@/components/design-system/atoms/icon/hero-icons/types';

export interface TabData {
  id: string;
  icon: (
    props: Omit<IconSaxIconProps, 'name'> | Omit<HeroIconsProps, 'name'>
  ) => React.ReactElement;
}

export const tabData: TabData[] = [
  {
    id: 'community',
    icon: (props: Omit<IconSaxIconProps, 'name'>) => (
      <IconSaxIcon size={74} strokeColor="none" name="roomies" {...props} />
    ),
  },
  {
    id: 'ready-homes',
    icon: (props: Omit<HeroIconsProps, 'name'>) => (
      <ReactSVG
        src={require('@assets/images/icons/steps/wishlist.svg')}
        width={74}
        height={74}
        {...props}
      />
    ),
  },
  {
    id: 'sustainability',
    icon: (props: Omit<IconSaxIconProps, 'name'>) => (
      <ReactSVG
        src={require('@assets/images/icons/steps/sustainability.svg')}
        width={74}
        height={74}
        {...props}
      />
    ),
  },
  {
    id: 'flexibility',
    icon: (props: Omit<IconSaxIconProps, 'name'>) => (
      <ReactSVG
        src={require('@assets/images/icons/steps/flexibility.svg')}
        width={74}
        height={74}
        {...props}
      />
    ),
  },
];
